import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import icon from "../../images/principles/confidentional.svg"
import { device } from "../../styles/media"

const PrincipleContainer = styled.div<{ isEven: boolean; isLast: boolean }>`
  width: 100%;
  max-width: 960px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-top: 56px;
  flex-direction: ${props => (props.isEven ? "row-reverse" : "row")};
  &:before {
    content: "";
    display: block;
    width: 3px;
    height: 40px;
    background: #6cbcde;
    position: absolute;
    border-radius: 1.5px;
    left: 0;
    right: 0;
    margin: auto;
    top: 13px;
  }
  &:after {
    content: "";
    display: ${props => (props.isLast ? "block" : "none")};
    width: 3px;
    height: 40px;
    background: #6cbcde;
    position: absolute;
    border-radius: 1.5px;
    left: 0;
    right: 0;
    margin: auto;
    bottom: -46px;
  }
  @media ${device.mobileL} {
    flex-direction: column;
    &:after,
    &:before {
      display: none;
    }
  }
`

const PrincipleTitle = styled.div<{ isEven: boolean }>`
  width: 50%;
  display: flex;
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: ${props => (props.isEven ? "left" : "right")};
  padding-right: ${props => (!props.isEven ? "64px" : "0")};
  padding-left: ${props => (props.isEven ? "64px" : "0")};
  justify-content: ${props => (!props.isEven ? "flex-end" : "flex-start")};
  .content {
    width: 100%;
    max-width: 217px;
  }
  @media ${device.mobileL} {
    order: 2;
    text-align: center;
    padding: 0;
    margin-bottom: 20px;
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const PrincipleText = styled.div<{ isEven: boolean }>`
  width: 50%;
  display: flex;
  justify-content: ${props => (props.isEven ? "flex-end" : "flex-start")};
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  text-align: ${props => (props.isEven ? "right" : "left")};
  padding-right: ${props => (props.isEven ? "64px" : "0")};
  padding-left: ${props => (!props.isEven ? "64px" : "0")};
  .content {
    width: 100%;
    max-width: 354px;
  }
  @media ${device.mobileL} {
    order: 3;
    text-align: center;
    padding: 0;
    width: 90%;
  }
`

const PrincipleCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 98px;
  height: 98px;
  border-radius: 50%;
  background: linear-gradient(
      35.3deg,
      #ecf1f3 11.75%,
      rgba(255, 255, 255, 0) 83.95%
    ),
    #ffffff;
  box-shadow: 0 15px 25px rgba(176, 178, 180, 0.4);
  left: 0;
  right: 0;
  margin: auto;
  @media ${device.mobileL} {
    order: 1;
    position: static;
    margin-bottom: 40px;
  }
`

const PrincipleImage = styled.img`
  width: ${props => props.width};
  height: ${props => props.height};
`

export const Principle = ({
  title,
  icon,
  text,
  isLast,
  isEven,
  iconHeight,
  iconWidth,
}) => {
  return (
    <PrincipleContainer isEven={isEven} isLast={isLast}>
      <PrincipleTitle isEven={isEven}>
        <p className="content">{title}</p>
      </PrincipleTitle>
      <PrincipleCircle>
        <PrincipleImage src={icon} width={iconWidth} height={iconHeight} />
      </PrincipleCircle>
      <PrincipleText isEven={isEven}>
        <p className="content">{text}</p>
      </PrincipleText>
    </PrincipleContainer>
  )
}

Principle.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.any,
  text: PropTypes.string,
  isLast: PropTypes.bool,
  isEven: PropTypes.bool,
  iconHeight: PropTypes.number,
  iconWidth: PropTypes.number,
}

Principle.defaultProps = {
  title: "Test",
  icon,
  text:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  isLast: false,
  isEven: false,
  iconHeight: 40,
  iconWidth: 30,
}
